import {
  Wrench, HardHat, Hammer, Truck, Package, ClipboardList,
  FolderOpen, Briefcase, Ruler, PenTool, Cog, ShieldCheck,
  Home, Building2, MapPin, Users, CalendarCheck, FileText,
  LayoutGrid, MessageSquare, Store, UserCircle, CalendarDays,
  Warehouse, MessageCircle, Contact,
} from 'lucide-react';
import type { IconName } from '../hooks/useModuleLabels.js';

const iconComponents: Record<IconName, React.FC<{ size?: number }>> = {
  Wrench, HardHat, Hammer, Truck, Package, ClipboardList,
  FolderOpen, Briefcase, Ruler, PenTool, Cog, ShieldCheck,
  Home, Building2, MapPin, Users, CalendarCheck, FileText,
  LayoutGrid, MessageSquare, Store, UserCircle, CalendarDays,
  Warehouse, MessageCircle, Contact,
};

/**
 * Geeft een Lucide icon component terug op basis van een string naam.
 * Gebruik: <ModuleIcon name="Wrench" size={20} />
 */
export function ModuleIcon({ name, size = 20 }: { name: IconName; size?: number }) {
  const Icon = iconComponents[name] || Wrench;
  return <Icon size={size} />;
}

export { iconComponents };
